/**
 * MAC WELDING TRESTLE CONFIGURATOR — DATA
 * ---------------------------------------------------------------
 * This is completely separate from the Welding Table Configurator.
 *
 * STEP ORDER
 * 1. Hole Size: 16mm / 28mm
 * 2. Trestle Type: ULTRA
 * 3. Thickness: 10mm / 15mm
 * 4. Trestle Length: 1000 / 1250 / 1500 / 1750 / 2000 / 2500mm
 * 5. Trestle Width: 250 / 500 / 750mm
 * 6. Base Option: Adjustable Feet / Heavy Duty Castors
 * 7. Leg Finish: RAW NO PAINT / RED / GREEN / BLUE / GREY / BLACK
 * 8. Additional Comments
 *
 * All prices should be entered EX VAT.
 * ---------------------------------------------------------------
 */

window.WELDING_TRESTLE_CONFIGURATOR_DATA = {
  currency: "£",
  vatRate: 0.20,

  holeSystems: [
    { id: "16D", label: "16mm", icon: "16d.png" },
    { id: "28D", label: "28mm", icon: "28d.png" }
  ],

  trestleTypes: [
    {
      id: "ultra",
      label: "ULTRA",
      image: "",
      previewImage: "",
      drawingPdf: ""
    }
  ],

  thicknesses: [
    { id: "10", label: "10mm", icon: "10mm.png" },
    { id: "15", label: "15mm", icon: "15mm.png" }
  ],

  lengths: [
    { id: "1000", label: "1000mm" },
    { id: "1250", label: "1250mm" },
    { id: "1500", label: "1500mm" },
    { id: "1750", label: "1750mm" },
    { id: "2000", label: "2000mm" },
    { id: "2500", label: "2500mm" }
  ],

  widths: [
    { id: "250", label: "250mm" },
    { id: "500", label: "500mm" },
    { id: "750", label: "750mm" }
  ],

  baseOptions: [
    {
      id: "adjustable_feet",
      label: "Adjustable Feet",
      icon: "adjustable-feet.png",
      price: 0,
      skuCode: "AF"
    },
    {
      id: "heavy_duty_castors",
      label: "Heavy Duty Castors",
      icon: "casters.png",
      price: null,
      skuCode: "HC"
    }
  ],

  finishes: [
    { id: "raw", label: "RAW NO PAINT", price: 0, skuCode: "RAW" },
    { id: "red", label: "RED", price: null, skuCode: "RED" },
    { id: "green", label: "GREEN", price: null, skuCode: "GRN" },
    { id: "blue", label: "BLUE", price: null, skuCode: "BLU" },
    { id: "grey", label: "GREY", price: null, skuCode: "GRY" },
    { id: "black", label: "BLACK", price: null, skuCode: "BLK" }
  ],

  /**
   * BASE PRICING
   * -------------------------------------------------------------
   * Price is looked up from:
   * Hole System > Thickness > Length > Width
   *
   * Example:
   * basePrices: {
   *   "16D": {
   *     "10": {
   *       "1000": {
   *         "250": 500,
   *         "500": 650,
   *         "750": 800
   *       }
   *     }
   *   }
   * }
   *
   * Leave combinations absent until prices are confirmed.
   */
  basePrices: {},

  /**
   * SHOPIFY VARIANT IDS
   * -------------------------------------------------------------
   * These can be mapped using the same combination key as pricing.
   * This lets us later choose the correct Shopify variant/weight.
   *
   * Key format:
   * HOLE-THICKNESS-LENGTH-WIDTH
   *
   * Example:
   * "16D-10-1000-250": "12345678901234"
   */
  shopifyVariantIds: {},

  /**
   * SKU FORMAT
   * -------------------------------------------------------------
   * Default generated SKU:
   * UT-[LENGTH]-[WIDTH]-[HOLE]-[THICKNESS]-[BASE]-[FINISH]
   *
   * Example:
   * UT-1500-500-16D-10-HC-BLK
   */
  skuPrefix: "UT"
};
